<ng-template #cross>
  <svg
    class="w-6 h-6 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M6 18 17.94 6M18 18 6.06 6"
    />
  </svg>
</ng-template>

<ng-template #spinner>
  <div role="status">
    <svg
      aria-hidden="true"
      class="w-6 h-6 animate-spin text-gray-200 dark:text-gray-600 fill-blue-500 dark:fill-blue-400"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
    <span class="sr-only">Loading...</span>
  </div>
</ng-template>

<ng-template #magnifierGlass>
  <svg
    class="w-6 h-6 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="2"
      d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    />
  </svg>
</ng-template>

<div id="map" class="h-full leaflet-container relative">
  <!-- Mobile Icon Bar -->
  <div
    class="lg:hidden search absolute top-0 right-0 h-full flex flex-col items-center justify-start space-y-4 py-4 bg-white dark:bg-gray-800"
  >
    <!-- Layer Control -->
    <button
      class="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-200 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700"
      (click)="toggleMobileItems('layerControlMobile')"
    >
      <svg
        class="w-6 h-6 text-gray-800 dark:text-gray-400"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M11 9h6m-6 3h6m-6 3h6M6.996 9h.01m-.01 3h.01m-.01 3h.01M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
        />
      </svg>
    </button>
    <!-- Time Slider -->
    <button
      class="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-200 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700"
      (click)="toggleMobileItems('timeSliderMobile')"
    >
      <svg
        class="w-6 h-6 text-gray-800 dark:text-gray-400"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    </button>
    <!-- Legend -->
    <button
      class="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-200 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700"
      (click)="toggleMobileItems('legendMobile')"
    >
      <svg
        class="w-6 h-6 text-gray-800 dark:text-gray-400"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M11 18h2M5.875 3h12.25c.483 0 .875.448.875 1v16c0 .552-.392 1-.875 1H5.875C5.392 21 5 20.552 5 20V4c0-.552.392-1 .875-1Z"
        />
      </svg>
    </button>
  </div>

  <!-- Search -->
  <div
    class="search absolute top-3.5 left-12 flex flex-col gap-2 items-start rounded-2xl p-3 bg-white dark:bg-gray-800 shadow-md"
  >
    <!-- Advanced Search Options -->
    <div class="flex flex-col gap-2" #advancedSearchContainer>
      <h5 class="text-base 2xl:text-base text-gray-900 dark:text-white">
        Search by parcel number
      </h5>
      <div class="self-stretch flex flex-col gap-1">
        <div class="flex flex-row justify-between items-center gap-2">
          <div class="flex flex-row items-center gap-2">
            <!-- County Input Field -->
            <div class="flex flex-col">
              <label
                for="county-dropdown"
                class="text-sm font-medium text-gray-900 dark:text-white"
                >County</label
              >
              <app-dropdown
                class="min-w-32"
                id="county-dropdown"
                [options]="countiesForSearchOptions.value()"
                [keyField]="'key'"
                [labelField]="'label'"
                [outputField]="'key'"
                [selectedKey]="advancedSearchForms.county().value()"
                (selectedKeyChange)="
                  advancedSearchForms.county().value.set($event)
                "
                dropdownPlacement="bottom"
                [hasNoneOption]="false"
                [disabled]="searching()"
              />
            </div>
            <!-- Apn -->
            <div class="flex flex-col relative flex-1">
              <label
                for="advanced-search"
                class="text-sm font-medium text-gray-900 dark:text-white"
                >APN</label
              >
              <input
                id="advanced-search"
                type="text"
                class="text-sm text-gray-900 dark:text-white rounded-lg bg-gray-50 dark:bg-gray-700 dark:placeholder-gray-400 disabled:bg-black/5 dark:disabled:bg-black/20 disabled:cursor-not-allowed"
                [ngClass]="
                  (
                    advancedSearchForms.apn().touched() &&
                    advancedSearchForms.apn().invalid()
                  ) ?
                    'border-red-500 dark:border-red-500 focus:ring-red-500 focus:border-red-500'
                  : 'border-gray-300 dark:border-gray-600 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500'
                "
                placeholder="Enter parcel number..."
                [formField]="advancedSearchForms.apn"
                (keydown.enter)="onSubmitAdvancedSearch()"
              />
            </div>
          </div>

          <!-- Search button -->
          <div class="flex flex-col">
            <label class="text-sm font-medium invisible" aria-hidden="true"
              >.</label
            >
            @if (!searching()) {
              <button type="submit" (click)="onSubmitAdvancedSearch()">
                <ng-container *ngTemplateOutlet="magnifierGlass" />
              </button>
            } @else {
              <ng-container *ngTemplateOutlet="spinner" />
            }
          </div>
        </div>
        <!-- Format helper -->
        @if (advancedSearchModel().county) {
          <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            {{
              getPlaceholderAndRegex(advancedSearchModel().county).placeholder
            }}
          </div>
        }
        <!-- Errors -->
        @if (advancedSearchErrors()) {
          <ul class="flex flex-col gap-1">
            @for (error of advancedSearchErrors(); track error) {
              <li class="text-sm text-red-500 dark:text-red-400">
                {{ error }}
              </li>
            }
          </ul>
        }
      </div>
    </div>

    <h6 class="text-xs 2xl:text-sm text-gray-900 dark:text-white">Or</h6>

    <!-- Regular Search -->
    <div
      class="self-stretch flex flex-col gap-1 items-stretch rounded-2xl bg-white dark:bg-gray-800 transition-all motion-expressive-fast-spatial"
      [ngClass]="{
        'bg-white dark:bg-gray-700 shadow-xl rounded-xl':
          searchResults && searchResults.length > 0,
      }"
    >
      <div
        class="group flex flex-row items-center gap-1 rounded-xl overflow-hidden border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 focus-within:ring focus-within:ring-blue-500 dark:placeholder-gray-400 dark:focus-within:ring-blue-500 transition-all motion-expressive-fast-spatial"
        #searchContainer
      >
        <input
          #searchInput
          type="text"
          id="default-search"
          class="w-full p-3 pe-1 text-sm bg-transparent text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 ring-0 border-0 peer disabled:opacity-60 disabled:cursor-not-allowed focus:ring-0 focus:border-transparent"
          placeholder="Search address, id, or lat, long..."
          (input)="onInputChange($event)"
        />
        <button
          type="submit"
          class="hidden group-focus-within:block p-3"
          (click)="clearSearch()"
        >
          <ng-container *ngTemplateOutlet="cross" />
        </button>
      </div>
      <!-- Geocoding Search results -->
      @if (searchResults && searchResults.length > 0) {
        <ul
          animate.enter="animate-enter-down"
          animate.leave="animate-leave-down"
          class="self-stretch flex flex-col gap-1 shadow-lg list-none max-h-60 rounded-xl overflow-y-auto bg-gray-50 dark:bg-gray-700 dark:border-gray-600"
        >
          @for (result of searchResults; track result) {
            <li
              (click)="selectLocation(result)"
              class="px-4 py-2 cursor-pointer text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              {{ result.place_name }}
            </li>
          }
        </ul>
      }
    </div>
  </div>

  <!-- Right Panels: Layer Control Panel and Time Slider Panel -->
  <div
    class="selection absolute md:top-1 md:right-1 p-1 max-w-xl lg:w-[30%] cursor-default"
    #layerControlPanelContainer
  >
    <!-- Layer Control Panel -->
    <div
      class="hidden lg:flex flex-col gap-4 md:w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 pt-5"
    >
      <!-- Layer Control Panel Title -->
      <div class="flex flex-col justify-between gap-2">
        <h5
          class="text-xl font-bold leading-none text-gray-900 dark:text-white pe-1"
        >
          Layers Control
        </h5>
        @if (type === "grower" || type === "entity") {
          <div class="flex flex-row items-center justify-between gap-2">
            <div
              class="text-base font-bold leading-none text-gray-900 dark:text-white pe-1 text-nowrap"
            >
              Select District
            </div>
            <!-- District Selection List -->
            <!-- <div class="max-w-128"> -->
            <app-dropdown
              [options]="clients"
              [keyField]="'id'"
              [labelField]="'name'"
              [outputField]="'id'"
              [(selectedKey)]="selectedClientId"
              dropdownPlacement="bottom"
            />
            <!-- </div> -->
          </div>
        }
      </div>
      <!-- Layer List -->
      <ul
        class="mb-3 w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
      >
        <li
          class="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600"
        >
          <div class="flex items-center ps-3">
            <input
              id="participatingFieldCheckbox"
              type="checkbox"
              [checked]="displayLayerList['claimed_fields']"
              (change)="updateLayerDisplay($event, 'claimed_fields')"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
            />
            <label
              for="participatingFieldCheckbox"
              class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >Claimed Fields</label
            >
          </div>

          <!-- Symbology for Claimed Field Layer [checked]="displayLayerList['claimed_fields']"
                  (change)="updateLayerDisplay($event, 'claimed_fields')" -->
          <div class="grid grid-cols-1 lg:grid-cols-1 gap-2 md:pl-9 pl-3 mb-4">
            <div class="flex items-center">
              <input
                id="labels"
                type="checkbox"
                (change)="toggleTooltips($event)"
                [checked]="showLabel"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
              />
              <label
                for="labels"
                class="w-full ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >Labels</label
              >
            </div>
            @if (labelZoomHintVisible) {
              <p class="ms-6 text-xs italic text-gray-500 dark:text-gray-400">
                Zoom in to see field labels
              </p>
            }

            <div class="flex items-center">
              <input
                [checked]="curSymbology === 'et'"
                id="et"
                type="radio"
                value=""
                name="symbology"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                (change)="onSymbologyUpdate($event, 'et')"
              />
              <label
                for="et"
                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                ET (in.)
              </label>
            </div>

            <div class="flex items-center">
              <input
                [checked]="curSymbology === 'precipitation'"
                id="precipitation"
                type="radio"
                value=""
                name="symbology"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                (change)="onSymbologyUpdate($event, 'precipitation')"
              />
              <label
                for="precipitation"
                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Precip (in.)
              </label>
            </div>

            <div class="flex items-center">
              <input
                [checked]="curSymbology === 'crop'"
                id="crop"
                type="radio"
                value=""
                name="symbology"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                (change)="onSymbologyUpdate($event, 'crop')"
              />
              <label
                for="crop"
                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Crop
              </label>
            </div>
          </div>
        </li>
        <li
          class="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600"
        >
          <div class="flex items-center ps-3">
            <input
              id="participatingFarmCheckbox"
              type="checkbox"
              [checked]="displayLayerList['not_claimed_fields']"
              (change)="updateLayerDisplay($event, 'not_claimed_fields')"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
            />
            <label
              for="participatingFarmCheckbox"
              class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >Unclaimed Fields</label
            >
          </div>
        </li>
      </ul>
    </div>

    <!-- Time Slider Panel -->
    <div
      class="hidden lg:block md:w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg pt-4 pb-1 px-4 mt-2"
      #timeSlider
    >
      <div class="flex justify-center items-center">
        <label
          class="text-xl font-bold leading-none text-gray-900 dark:text-white pe-1"
        >
          {{ dateListTimeSlider[dateTimeSlider] }}
        </label>
      </div>
      @if (isSelectedEtDateFailed) {
        <p
          role="status"
          class="text-center text-sm text-gray-600 dark:text-gray-300"
        >
          Unable to load ET data.
          <button
            type="button"
            class="underline"
            (click)="etDateRequested.emit(dateListTimeSlider[dateTimeSlider])"
          >
            Retry
          </button>
        </p>
      } @else if (isSelectedEtDateUnavailable) {
        <p
          role="status"
          class="text-center text-sm text-gray-600 dark:text-gray-300"
        >
          ET data unavailable for this date.
        </p>
      }

      <div class="relative mt-2 mb-2">
        <label for="labels-range-input" class="sr-only">Labels range</label>
        <div class="flex justify-between text-xs mb-3">
          @for (year of TimeSliderLableList; track year) {
            <span class="text-sm text-gray-500 dark:text-gray-400">{{
              year
            }}</span>
          }
        </div>

        <input
          id="labels-range-input"
          type="range"
          [min]="minDate"
          [max]="maxDate"
          class="w-full h-2 mb-3 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
          [(value)]="dateTimeSlider"
          (input)="updateTimeSlider($event)"
        />

        <!--hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white-->

        <!-- Time Slider Buttons -->
        <div class="flex justify-center space-x-4">
          <!-- Move to the previous month -->
          <svg
            class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            (click)="moveTimeSliderMonth(-1)"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m17 16-4-4 4-4m-6 8-4-4 4-4"
            />
          </svg>

          <!-- Move to the previous date -->
          <svg
            class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            (click)="moveTimeSliderDate(-1)"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m14 8-4 4 4 4"
            />
          </svg>

          <!-- Play the Time Slider -->
          @if (isPlay) {
            <svg
              class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
              (click)="togglePlayTimeSlider()"
            >
              <path
                fill-rule="evenodd"
                d="M8 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8Zm7 0a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1Z"
                clip-rule="evenodd"
              />
            </svg>
          } @else {
            <svg
              class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
              (click)="togglePlayTimeSlider()"
            >
              <path
                fill-rule="evenodd"
                d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z"
                clip-rule="evenodd"
              />
            </svg>
          }

          <!-- Move to the next date -->
          <svg
            class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            (click)="moveTimeSliderDate(1)"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m10 16 4-4-4-4"
            />
          </svg>

          <!-- Move to the next month -->
          <svg
            class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            (click)="moveTimeSliderMonth(1)"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m7 16 4-4-4-4m6 8 4-4-4-4"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Layer Control Panel: Mobile  p-1 max-w-xl lg:w-[30%] cursor-default-->
  <div
    class="selection absolute bottom-2 right-11 bg-white selection dark:bg-gray-800 rounded-lg shadow-lg px-3 py-2"
    #layerControlPanelMobileContainer
    [ngClass]="
      displayMobileItems['layerControlMobile'] ?
        ['block', 'lg:hidden']
      : ['hidden', 'lg:hidden']
    "
  >
    <!-- Layer List -->
    <ul
      class="px-3 w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
    >
      <li
        class="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600"
      >
        <div class="flex items-center ps-3">
          <input
            id="participatingFieldCheckboxMobile"
            type="checkbox"
            [checked]="displayLayerList['claimed_fields']"
            (change)="updateLayerDisplay($event, 'claimed_fields')"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
          />
          <label
            for="participatingFieldCheckbox"
            class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >Claimed Fields</label
          >
        </div>

        <!-- Symbology for Claimed Field Layer [checked]="displayLayerList['claimed_fields']"
              (change)="updateLayerDisplay($event, 'claimed_fields')" -->
        <div class="grid grid-cols-1 gap-0.5 md:pl-9 pl-5 mb-4">
          <div class="flex items-center">
            <input
              id="labelsMobile"
              type="checkbox"
              (change)="toggleTooltips($event)"
              [checked]="showLabel"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
            />
            <label
              for="labels"
              class="w-full ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >Labels</label
            >
          </div>
          @if (labelZoomHintVisible) {
            <p class="ms-6 text-xs italic text-gray-500 dark:text-gray-400">
              Zoom in to see field labels
            </p>
          }

          <div class="flex items-center">
            <input
              [checked]="curSymbology === 'et'"
              id="etMobile"
              type="radio"
              value=""
              name="symbologyMobile"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              (change)="onSymbologyUpdate($event, 'et')"
            />
            <label
              for="etMobile"
              class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              ET
            </label>
          </div>

          <div class="flex items-center">
            <input
              [checked]="curSymbology === 'precipitation'"
              id="precipitationMobile"
              type="radio"
              value=""
              name="symbologyMobile"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              (change)="onSymbologyUpdate($event, 'precipitation')"
            />
            <label
              for="precipitationMobile"
              class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              Precip
            </label>
          </div>

          <div class="flex items-center">
            <input
              [checked]="curSymbology === 'crop'"
              id="cropMobile"
              type="radio"
              value=""
              name="symbologyMobile"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              (change)="onSymbologyUpdate($event, 'crop')"
            />
            <label
              for="cropMobile"
              class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              Crop
            </label>
          </div>
        </div>
      </li>
      <li
        class="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600"
      >
        <div class="flex items-center ps-3">
          <input
            id="participatingFarmCheckbox"
            type="checkbox"
            [checked]="displayLayerList['not_claimed_fields']"
            (change)="updateLayerDisplay($event, 'not_claimed_fields')"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
          />
          <label
            for="participatingFarmCheckbox"
            class="w-full py-3 ms-2 text-xs font-medium text-gray-900 dark:text-gray-300"
            >Unclaimed Fields</label
          >
        </div>
      </li>
    </ul>
  </div>

  <!-- Time Slider Panel: Mobile -->
  <div
    class="selection max-w-56 absolute bottom-0.5 right-11 pt-3 px-3 pb-1 bg-white dark:bg-gray-800 rounded-lg shadow-lg"
    #timeSliderMobileContainer
    [ngClass]="
      displayMobileItems['timeSliderMobile'] ?
        ['block', 'lg:hidden']
      : ['hidden', 'lg:hidden']
    "
  >
    <div class="flex justify-center items-center">
      <label
        class="text-xl font-bold leading-none text-gray-900 dark:text-white pe-1"
      >
        {{ dateListTimeSlider[dateTimeSlider] }}
      </label>
    </div>
    @if (isSelectedEtDateFailed) {
      <p
        role="status"
        class="text-center text-sm text-gray-600 dark:text-gray-300"
      >
        Unable to load ET data.
        <button
          type="button"
          class="underline"
          (click)="etDateRequested.emit(dateListTimeSlider[dateTimeSlider])"
        >
          Retry
        </button>
      </p>
    } @else if (isSelectedEtDateUnavailable) {
      <p
        role="status"
        class="text-center text-sm text-gray-600 dark:text-gray-300"
      >
        ET data unavailable for this date.
      </p>
    }

    <div class="relative mt-2 mb-2">
      <label for="labels-range-input" class="sr-only">Labels range</label>
      <div class="flex justify-between text-xs mb-3">
        @for (year of TimeSliderLableList; track year) {
          <span class="text-sm text-gray-500 dark:text-gray-400">{{
            year
          }}</span>
        }
      </div>

      <input
        id="labels-range-input"
        type="range"
        [min]="minDate"
        [max]="maxDate"
        class="w-full h-2 mb-3 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
        [(value)]="dateTimeSlider"
        (input)="updateTimeSlider($event)"
      />

      <!-- Time Slider Buttons -->
      <div class="flex justify-center space-x-4">
        <!-- Move to the previous month -->
        <svg
          class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          (click)="moveTimeSliderMonth(-1)"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m17 16-4-4 4-4m-6 8-4-4 4-4"
          />
        </svg>

        <!-- Move to the previous date -->
        <svg
          class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          (click)="moveTimeSliderDate(-1)"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m14 8-4 4 4 4"
          />
        </svg>

        <!-- Play the Time Slider -->
        @if (isPlay) {
          <svg
            class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
            (click)="togglePlayTimeSlider()"
          >
            <path
              fill-rule="evenodd"
              d="M8 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8Zm7 0a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1Z"
              clip-rule="evenodd"
            />
          </svg>
        } @else {
          <svg
            class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
            (click)="togglePlayTimeSlider()"
          >
            <path
              fill-rule="evenodd"
              d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z"
              clip-rule="evenodd"
            />
          </svg>
        }

        <!-- Move to the next date -->
        <svg
          class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          (click)="moveTimeSliderDate(1)"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m10 16 4-4-4-4"
          />
        </svg>

        <!-- Move to the next month -->
        <svg
          class="w-7 h-7 text-gray-600 dark:text-gray-300 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          (click)="moveTimeSliderMonth(1)"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m7 16 4-4-4-4m6 8 4-4-4-4"
          />
        </svg>
      </div>
    </div>
  </div>

  <!-- Legend -->
  <div
    class="hidden lg:block selection absolute bottom-10 left-1 p-1 w-[15%] max-w-56 cursor-default"
    #legendPanelContainer
  >
    <div
      class="map-legend-card w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-2.5"
    >
      <!-- Legend Title -->
      <div class="flex justify-between mb-3">
        <div class="flex justify-center items-center">
          <h5
            class="text-base font-bold leading-none text-gray-900 dark:text-white pe-1"
          >
            Legend
          </h5>
        </div>
      </div>

      <!-- Legend Content -->
      <div class="flex items-center">
        <!-- Flex container for alignment -->
        <div class="w-4 h-4 bg-gray-500 mr-2 mb-4"></div>
        <!-- Blue polygon (square) -->
        <span class="text-xs 2xl:text-sm text-gray-800 dark:text-white mb-4"
          >Unclaimed Fields</span
        >
        <!-- Label -->
      </div>

      @if (curSymbology === "et") {
        <!-- ET -->
        <div class="flex justify-between mb-3">
          <div class="flex justify-center items-center">
            <h6
              class="text-xs font-bold leading-none text-gray-900 dark:text-white pe-1"
            >
              Daily ET (In.)
            </h6>
          </div>
        </div>
        <div class="flex items-center">
          <!-- Flex container for alignment -->
          <div
            style="
              width: 30px;
              height: 60px;
              margin-right: 5px;
              background: linear-gradient(
                to bottom,
                #5e4fa2 5%,
                #486cb0 10%,
                #3288bd 15%,
                #4ca5b1 20%,
                #66c2a5 25%,
                #89d0a5 30%,
                #abdda4 35%,
                #c9e99e 40%,
                #e6f598 45%,
                #f2eb92 50%,
                #fee08b 55%,
                #fec776 60%,
                #fdae61 65%,
                #f98e52 70%,
                #f46d43 75%,
                #e55649 80%,
                #d53e4f 85%,
                #ba2049 90%,
                #9e0142 95%,
                #5c0003 100%
              );
            "
          ></div>
          <div class="flex flex-col justify-center dark:text-white">
            <div class="mb-9">0.3</div>
            <div>0</div>
          </div>
        </div>
      } @else if (curSymbology === "precipitation") {
        <!-- Precip -->
        <div class="flex justify-between mb-3">
          <div class="flex justify-center items-center">
            <h6
              class="text-xs font-bold leading-none text-gray-900 dark:text-white pe-1"
            >
              Daily Precipitation (In.)
            </h6>
          </div>
        </div>
        <div class="flex items-center">
          <!-- Flex container for alignment -->
          <div
            style="
              width: 30px;
              height: 60px;
              margin-right: 5px;
              background: linear-gradient(
                to bottom,
                #173f6d 5%,
                #214773 10%,
                #2b4f7a 15%,
                #345780 20%,
                #3d5f87 25%,
                #45678d 30%,
                #4e6f94 35%,
                #57789a 40%,
                #6180a1 45%,
                #6a89a7 50%,
                #7392ae 55%,
                #7d9ab4 60%,
                #87a3bb 65%,
                #91acc2 70%,
                #9bb4c8 75%,
                #a6bdcf 80%,
                #b0c6d6 85%,
                #bbcfdd 90%,
                #c6d8e4 95%,
                #d1e1eb 100%
              );
            "
          ></div>
          <div class="flex flex-col justify-center dark:text-white">
            <div class="mb-9">4</div>
            <div>0</div>
          </div>
        </div>
      } @else if (curSymbology === "crop") {
        <!-- Crop -->
        <div class="flex justify-between mb-3">
          <div class="flex justify-center items-center">
            <h6
              class="text-xs font-bold leading-none text-gray-900 dark:text-white pe-1"
            >
              Crop
            </h6>
          </div>
        </div>
        <!-- Legend Content -->
        <div class="crop-legend-scroll pr-1">
          @for (subCropLegend of cropLegend; track subCropLegend) {
            <div class="flex items-start gap-1.5 py-0.5">
              <!-- Flex container for alignment -->
              <div
                class="mt-0.5 h-3 w-3 shrink-0"
                [style.backgroundColor]="subCropLegend.color"
              ></div>
              <!-- Blue polygon (square) -->
              <span
                class="text-xs 2xl:text-sm leading-tight text-gray-800 dark:text-white"
                >{{ subCropLegend.crop }}</span
              >
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Legend: Mobile -->
  <div
    class="selection absolute bottom-0.5 right-10 p-1 max-w-56 cursor-default"
    #legendPanelMobileContainer
    [ngClass]="
      displayMobileItems['legendMobile'] ?
        ['block', 'lg:hidden']
      : ['hidden', 'lg:hidden']
    "
  >
    <div
      class="map-legend-card w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-2.5"
    >
      <!-- Legend Title -->
      <div class="flex justify-between mb-3">
        <div class="flex justify-center items-center">
          <h5
            class="text-base font-bold leading-none text-gray-900 dark:text-white pe-1"
          >
            Legend
          </h5>
        </div>
      </div>

      <!-- Legend Content -->
      <div class="flex items-center">
        <!-- Flex container for alignment -->
        <div class="w-4 h-4 bg-gray-500 mr-2 mb-4"></div>
        <!-- Blue polygon (square) -->
        <span class="text-xs 2xl:text-sm text-gray-800 dark:text-white mb-4"
          >Unclaimed Fields</span
        >
        <!-- Label -->
      </div>
      @if (curSymbology === "et") {
        <!-- ET -->
        <div class="flex justify-between mb-3">
          <div class="flex justify-center items-center">
            <h6
              class="text-xs font-bold leading-none text-gray-900 dark:text-white pe-1"
            >
              Daily ET (In.)
            </h6>
          </div>
        </div>
        <div class="flex items-center">
          <!-- Flex container for alignment -->
          <div
            style="
              width: 30px;
              height: 60px;
              margin-right: 5px;
              background: linear-gradient(
                to bottom,
                #5e4fa2 5%,
                #486cb0 10%,
                #3288bd 15%,
                #4ca5b1 20%,
                #66c2a5 25%,
                #89d0a5 30%,
                #abdda4 35%,
                #c9e99e 40%,
                #e6f598 45%,
                #f2eb92 50%,
                #fee08b 55%,
                #fec776 60%,
                #fdae61 65%,
                #f98e52 70%,
                #f46d43 75%,
                #e55649 80%,
                #d53e4f 85%,
                #ba2049 90%,
                #9e0142 95%,
                #5c0003 100%
              );
            "
          ></div>
          <div class="flex flex-col justify-center dark:text-white">
            <div class="mb-9">0.3</div>
            <div>0</div>
          </div>
        </div>
      } @else if (curSymbology === "precipitation") {
        <!-- Precip -->
        <div class="flex justify-between mb-3">
          <div class="flex justify-center items-center">
            <h6
              class="text-xs font-bold leading-none text-gray-900 dark:text-white pe-1"
            >
              Daily Precipitation (In.)
            </h6>
          </div>
        </div>
        <div class="flex items-center">
          <!-- Flex container for alignment -->
          <div
            style="
              width: 30px;
              height: 60px;
              margin-right: 5px;
              background: linear-gradient(
                to bottom,
                #173f6d 5%,
                #214773 10%,
                #2b4f7a 15%,
                #345780 20%,
                #3d5f87 25%,
                #45678d 30%,
                #4e6f94 35%,
                #57789a 40%,
                #6180a1 45%,
                #6a89a7 50%,
                #7392ae 55%,
                #7d9ab4 60%,
                #87a3bb 65%,
                #91acc2 70%,
                #9bb4c8 75%,
                #a6bdcf 80%,
                #b0c6d6 85%,
                #bbcfdd 90%,
                #c6d8e4 95%,
                #d1e1eb 100%
              );
            "
          ></div>
          <div class="flex flex-col justify-center dark:text-white">
            <div class="mb-9">4</div>
            <div>0</div>
          </div>
        </div>
      } @else if (curSymbology === "crop") {
        <!-- Crop -->
        <div class="flex justify-between mb-3">
          <div class="flex justify-center items-center">
            <h6
              class="text-xs font-bold leading-none text-gray-900 dark:text-white pe-1"
            >
              Crop
            </h6>
          </div>
        </div>
        <!-- Legend Content -->
        <div class="crop-legend-scroll pr-1">
          @for (subCropLegend of cropLegend; track subCropLegend) {
            <div class="flex items-start gap-1.5 py-0.5">
              <!-- Flex container for alignment -->
              <div
                class="mt-0.5 h-3 w-3 shrink-0"
                [style.backgroundColor]="subCropLegend.color"
              ></div>
              <!-- Blue polygon (square) -->
              <span
                class="text-xs 2xl:text-sm leading-tight text-gray-800 dark:text-white"
                >{{ subCropLegend.crop }}</span
              >
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Info Icon -->
  <div
    class="selection lg-block absolute bottom-1.5 right-16 p-1 cursor-default"
  >
    <button
      type="button"
      aria-label="Info"
      class="group inline-flex items-center justify-center w-11 h-11 rounded-md bg-white/95 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md ring-1 ring-black/5 dark:ring-white/5 transition"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
    >
      <!-- Info icon -->
      <svg
        class="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-gray-800 dark:group-hover:text-white transition"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm0 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm1-5.034V12a1 1 0 0 1-2 0v-1.418a1 1 0 0 1 1.038-.999 1.436 1.436 0 0 0 1.488-1.441 1.501 1.501 0 1 0-3-.116.986.986 0 0 1-1.037.961 1 1 0 0 1-.96-1.037A3.5 3.5 0 1 1 11 11.466Z"
        />
      </svg>
    </button>
    <!-- Tooltip class="absolute top-6 z-10 -left-56 text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-xs w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 transition-opacity duration-300 ease-in-out" -->
    <div
      class="absolute bottom-14 right-0.5 z-10 p-2 text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-xs w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 transition-opacity duration-300 ease-in-out"
      [ngClass]="isHovered ? 'opacity-100 visible' : 'opacity-0 invisible'"
    >
      <p>
        Default basemap is Mapbox Imagery. It may not represent very recent
        changes to the land surface and is a compilation of relatively recent
        imagery. The date of collection varies across the landscape.
      </p>
    </div>
  </div>
</div>
